// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.View-body-1b94{height:calc(100% - 32px);overflow:auto}.View-page-1b94{display:flex;align-items:center;width:100%;height:1px;min-height:100%;animation:1000ms ease-in-out View-appearance-1b94}@keyframes View-appearance-1b94{from{opacity:0}to{opacity:1}}`, "",{"version":3,"sources":["webpack://./src/page/tryon/View.module.scss"],"names":[],"mappings":"AAAA,gBACE,wBAAA,CACA,aAAA,CAGF,gBACE,YAAA,CACA,kBAAA,CAEA,UAAA,CACA,UAAA,CACA,eAAA,CAEA,iDAAA,CAGF,gCACE,KACE,SAAA,CAGF,GACE,SAAA,CAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"body": `View-body-1b94`,
	"page": `View-page-1b94`,
	"appearance": `View-appearance-1b94`
};
module.exports = ___CSS_LOADER_EXPORT___;
